import React, { useEffect, useState } from "react";
import { Paper, withStyles } from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import * as actions from "../../../actions/fcm";
import * as category  from "../../../actions/category";
import * as department  from "../../../actions/department";
import * as service from "../../../actions/service";
import * as coupon from "../../../actions/coupon";
import * as offer from "../../../actions/offer";
import * as user from "../../../actions/user";
import FormDialogAddFcm from "../formDialog/FormDialogAddFcm";
//import FormDialogEditFcm from "../formDialog/FormDialogEditFcm";
import FormDialogDeleteFcm from "../formDialog/FormDialogDeleteFcm";

const styles = theme => ({
    paperTable: {
        padding: theme.spacing(0),
    }
})

const FcmTable = ({ classes, ...props }) => {
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(15)
    const [category, setCategory] = useState({})
    useEffect(() => {    
        props.fetchPagination(1, rowsPerPage) 
        props.fetchServices();
        props.fetchOffers();
        props.fetchCoupons();
        props.fetchUsers()
        
        console.log('hhh',props)
    
    }, [])

    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage)
    };

    const handleChangeRowsPerPage = async (rowsPerPage) => {
        await setRowsPerPage(rowsPerPage);
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    };

    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText)
    };

    const handleFilterChange = async (title) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title)
    };

    const refresh = async () => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage)
    }
    
    const columns = [
        {
            name: "id",
            label: "ID",
            options: {
                display: false,
                filter: false,
                sort: false,
            }
        },
        {
            name: "title",
            label: "Title",
            options: {
                filter: false,
                sort: false,
             
            },
          
        },
       
      
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                sort: false,
             
            }
        },
        {
            name: "image",
            label: "Image",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
        {
            name: "redirectionType",
            label: "Redirection Type",
            options: {
                filter: false,
                sort: false,
             
            }
        },
        
        {
            name: "redirectionObj.title",
            label: "Redirection Item",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "sendToAll",
            label: "sendToAll",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
        {
            name: "users",
            label: "users",
            options: {
                filter: false,
                sort: false,
                display: false,
            }
        },
       
        {
            name: "",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customHeadRender: (columnMeta, handleToggleColumn) => {
                    return (
                        <th key={columnMeta.index} style={{paddingRight: "16px"}}>
                            <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                                <FormDialogAddFcm component={Paper}  
                                    create={props.create}
                                    refresh={refresh}
                                    offers ={ props.offers}
                                    services ={ props.services}
                                    coupons ={ props.coupons}
                                    users ={ props.users}
                                />
                            </div>
                        </th>
                    );
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div style={{display:"flex", flexDirection:"row", justifyContent:"flex-end"}}>
                            {/* <FormDialogEditFcm
                                dataFcm={tableMeta.rowData}
                                update={props.update}
                                categories ={ props.categories}
                                departments ={ props.departments}
                            /> */}
                            <FormDialogDeleteFcm 
                                dataFcm={tableMeta.rowData}
                                delete={props.delete}
                                refresh={refresh}
                            />
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        filter: false,
        filterType: 'textField',
        responsive: 'stacked',
        selectableRows: false,
        rowsPerPageOptions: [5, 10, 25],
        serverSide: true,
        viewColumns: false,
        print: false,
        download: false,

        rowsPerPage: rowsPerPage,
        count: props?.meta?.totalDocs || 0,
        page: page,

        onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                handleChangePage(tableState.page)
                break;

            case 'changeRowsPerPage':
                handleChangeRowsPerPage(tableState.rowsPerPage)
                break;

            case 'search':
                handleSearch(tableState.searchText)
                break;

            case 'filterChange':
                handleFilterChange(tableState.filterList[1], tableState.filterList[2])
                break;
            
            case 'resetFilters':
                handleSearch("")
                break;
                 
              default:
                break;
            }
        },
    };
    
    return (
        <MUIDataTable className={classes.paperTable}
            data={props.fcms}
            columns={columns}
            options={options}
        />
    );
}

const mapStateToProps = state => ({
    fcms: state?.fcm?.fcms,
    meta: state?.fcm?.metaFcm,
    categories: state.category.categories,
    departments: state.department.departments,
    services: state.service.services,
    offers: state.offer.offers,
    coupons: state.coupon.coupons,
    users: state.user.users
})

const mapActionToProps = {
    fetchPagination: actions.Pagination,
    create: actions.create,
    update: actions.update,
    delete: actions.Delete,
    fetchCategories : category.fetchAll,
    fetchDepartments : department.fetchAll,
    fetchServices : service.fetchAll,
    fetchOffers: offer.fetchAll,
    fetchCoupons: coupon.fetchAll,
    fetchUsers: user.fetchAll
}

export default connect(mapStateToProps, mapActionToProps)(withStyles(styles)(FcmTable));